export function PageHeader({ eyebrow, title, description, actions, testid }) {
  return (
    <header
      className="flex items-start justify-between gap-6 px-8 py-8 border-b border-neutral-200"
      data-testid={testid || "page-header"}
    >
      <div className="min-w-0">
        {eyebrow && (
          <div className="text-[10px] uppercase tracking-[0.2em] text-neutral-500 mb-2 font-semibold">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-neutral-900">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-neutral-500 mt-2 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
}

export function Section({ children, className = "" }) {
  return <section className={`px-8 py-6 ${className}`}>{children}</section>;
}
